import { axiosInstance } from '.'
import { MANUAL_SHARE_SALE_V1 } from './endpoints'

export type ManualShareSalePayload = {
  investorId: number
  shares: number
  pricePerShare: number
  saleDate?: string
  note?: string
  idempotencyKey?: string
}

export const manualEntryServices = {
  createManualShareSale: async (
    opportunityId: string | number,
    payload: ManualShareSalePayload,
  ) => {
    try {
      const data = await axiosInstance.post(MANUAL_SHARE_SALE_V1(opportunityId), payload)
      return { data: data.data, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
}
